import {
  isString,
  times
} from "lodash";
import moment from 'moment';
import {
  Component
} from 'react';
import {
  SUGGESTION_TYPE__SCHOOL
} from '../../lib/Crunchbase.lib';
import {
  Obj
} from '../../lib/Object.lib';
import {
  trim
} from '../../lib/String.lib';
import Box from '../Layout/Wrappers/Box';
import Menu from '../Layout/Wrappers/Menu';
import Typography from '../Layout/Wrappers/Typography';

const MONTHS = [
  { id: 1, label: 'January' },
  { id: 2, label: 'February' },
  { id: 3, label: 'March' },
  { id: 4, label: 'April' },
  { id: 5, label: 'May' },
  { id: 6, label: 'June' },
  { id: 7, label: 'July' },
  { id: 8, label: 'August' },
  { id: 9, label: 'September' },
  { id: 10, label: 'October' },
  { id: 11, label: 'November' },
  { id: 12, label: 'December' }
];

export function getMonthId({ month }) {
  if (isString(month)) {
    month = Obj(
      MONTHS.find(
        ({ label }) => (new RegExp(month, 'i')).test(label)
      )
    ).id;
  }
  return +month || null;
}

class YearsDropdown extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      startYear: (
        (this.props.type === SUGGESTION_TYPE__SCHOOL)
          ? Number(moment().add(10, 'years').format('YYYY'))
          : Number(moment().format('YYYY'))
      ),
      month: 0,
      year: 0,
    }
  }

  componentDidMount() {
    this.setState({
      month: getMonthId({ month: this.props.month }),
      year: +this.props.year || null
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (this.props.month !== prevProps.month) {
      this.setState({
        month: getMonthId({ month: this.props.month }),
      });
    }

    if (
      (
        !!this.props.year ||
        this.props.year
      ) &&
      this.props.year !== prevProps.year
    ) {
      this.setState({
        year: +this.props.year || null
      });
    }
  }

  render() {
    const { startYear, month, year } = this.state;
    const { onChangeHandler } = this.props;

    const _onChange = ({
      month = this.state.month,
      year = this.state.year
    }) => {
      const monthString = trim(
        Obj(
          MONTHS.find(
            ({ id }) => (id === month)
          )
        ).label
      ) || null;
      this.setState(
        {
          month,
          year,
        },
        () => {
          onChangeHandler(
            month,
            year,
            monthString
          );
        }
      );
    }

    return (
      <Box row className={this.props.className}>
        <Box column flex1 mr>
          <Menu dropdown
            name="selectValue"
            value={month}
            onChange={(month) => _onChange({ month })}
            onClose={this.props.onClose}
            variant='standard'
            className='mr-1'
            style={{ width: 120 }}
            paperStyle={{ maxHeight: '50vh', minHeight: 320 }}
            options={MONTHS}
          />
          <Typography className='f-sm c-gray px-05'>
            Month
          </Typography>
        </Box>
        <Box column flex1>
          <Menu dropdown
            name="selectValue"
            value={year}
            onChange={(year) => _onChange({ year })}
            onClose={this.props.onClose}
            style={{ width: 120 }}
            paperStyle={{ maxHeight: '50vh', minHeight: 320 }}
            options={times(70,
              (index) => {
                const _year = startYear - index;
                return ({
                  id: _year,
                  label: String(_year)
                });
              }
            )}
          />
          <Typography className='f-sm c-gray px-05'>
            Year
          </Typography>
        </Box>
      </Box>
    );
  }
}

export default YearsDropdown;
